interface Attributes {
  crop: string;
}

interface BaseLayer {
  name: string;
}

interface ZoneSummary {
  id: string;
  acres: number;
}

interface Summary {
  zones: ZoneSummary[];
}
export interface PrescriptionToSave {
  activityType: string;
  activityUuid: string;
  attributes: Attributes;
  bases: BaseLayer[];
  tag: string;
  primary: boolean;
  fieldId: number;
  fieldUuid: string;
  updateTime: string;
  fmzId: string;
  fmzName: string;
  fmzVersion: number;
  id: string;
  prescriptionId: string;
  name: string;
  summary: Summary;
  geometry: string;
}

export interface UpdatePrescriptionResponse {
  updatePrescriptionDetails: {
    message: string;
    id: string;
  };
}

export enum SaveStatus {
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
}

export interface PrescriptionSavingStatus {
  prescriptionId: string;
  fieldId: string;
  status: SaveStatus;
  errorMessage?: string;
}
